<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 3.75h12v16.5l-2.25-1.5-1.88 1.5L12 18.75l-1.87 1.5-1.88-1.5L6 20.25V3.75Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 8h6M9 11.5h6M9 15h3.5"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
    />
  </svg>
</template>
